// extracted by mini-css-extract-plugin
export var logo = "_ik-2";
export var logoWrapper = "_ik-1";
export var strip = "_ik-0";